import React from 'react'
import {Row} from '@modifi/ui'
import {useInputValue} from '@modifi/plugin-forms'
import {
  LEGAL_REPRESENTATIVE_POLITICALLY_EXPOSED,
  LEGAL_REPRESENTATIVE_POLITICALLY_EXPOSED_REASON,
  withHideIfNotVisible,
  useInputNameSpecificTranslationKey,
  InputComponent,
  RadioGroupComponent,
} from '@modifi/plugin-onboarding'

import {FormInputComponentCol} from '../../../../../plugins/onboarding'
import {TranslateFn} from '../../../../../types/common'

type PoliticallyExposedInputRowProps = {
  t: TranslateFn
}

const PoliticallyExposedInputRow: React.FC<PoliticallyExposedInputRowProps> = ({t}) => {
  const {value} = useInputValue({
    name: LEGAL_REPRESENTATIVE_POLITICALLY_EXPOSED,
    defaultValue: false,
  })
  const inputNameSpecific = useInputNameSpecificTranslationKey()

  const politicallyExposedRadioOptions = [
    {
      label: t(inputNameSpecific(LEGAL_REPRESENTATIVE_POLITICALLY_EXPOSED, 'value.true')),
      value: true,
      colProps: {
        auto: true,
      },
    },
    {
      label: t(inputNameSpecific(LEGAL_REPRESENTATIVE_POLITICALLY_EXPOSED, 'value.false')),
      value: false,
      colProps: {
        auto: true,
      },
    },
  ]

  return (
    <>
      <Row mb={16}>
        <FormInputComponentCol
          t={t}
          inputName={LEGAL_REPRESENTATIVE_POLITICALLY_EXPOSED}
          inputComponent={RadioGroupComponent}
          options={politicallyExposedRadioOptions}
          colProps={{md: 12}}
        />
      </Row>
      {value && (
        <Row>
          <FormInputComponentCol
            t={t}
            inputName={LEGAL_REPRESENTATIVE_POLITICALLY_EXPOSED_REASON}
            inputComponent={InputComponent}
            colProps={{md: 12}}
          />
        </Row>
      )}
    </>
  )
}

export default withHideIfNotVisible(
  PoliticallyExposedInputRow,
  LEGAL_REPRESENTATIVE_POLITICALLY_EXPOSED
)
